import { FIVE_MINUTES_IN_MILLISECONDS } from '@/constants';
import queryKeys from '@/constants/queryKeys';
import { getUnreadNotificationsCount } from '@/services/api/requests/notifications';
import { useQuery } from '@tanstack/react-query';

const useGetUnreadNotificationsCount = () => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.notifications.unreadCount],
    refetchInterval: FIVE_MINUTES_IN_MILLISECONDS,
    queryFn: async () => {
      const response = await getUnreadNotificationsCount();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useGetUnreadNotificationsCount;
